export default __webpack_public_path__ + "assets/images/f30633063449f34d2314c7117a19504f.jpg";